import React, { useEffect, useState } from 'react'
import { Modal } from 'semantic-ui-react';
import PropTypes from "prop-types";
import { useTextResources } from '../../language';
import GridPanel from '../GridPanel';
import { Popup, } from 'semantic-ui-react'
import './style.css';

const ReservationsUpdateStatusModal = ({ data, startOpen, onClose }) => {
    const text = useTextResources();
    const [open, setOpen] = useState(startOpen);

    useEffect(() => {
        if (!data || !Array.isArray(data)) return;

        data.forEach(reservationViewModel => {
            if (reservationViewModel.ErrorCode == 10167 || reservationViewModel.ErrorCode == 12354)
                reservationViewModel.ErrorMessages = text('CantCheckOutFolioIsOpen');
        });
    }, [data]);

    const close = () => {
        onClose?.();
        setOpen(false);
    }

    const statusIconFormatter = ({ row }) => {
        return row ?
            <span className={`status-icon ${row.ErrorMessages ? 'errorStatus' : 'successStatus'}`}></span> : ""
    }

    const toolTipFormatter = ({ value, row }) => {
        return row ? (
            <Popup content={value} trigger={<div>{value}</div>} />) : value || ""
    };

    const gridOptions = {
        columns: [
            { name: 'Status', title: text('Status'), formatter: statusIconFormatter },
            { name: 'Number', title: text('ReservationNumber') },
            { name: 'RoomNumber', title: text('RoomNumber') },
            { name: 'GuestFullName', title: text('Guest') },
            { name: 'ErrorMessages', title: text('Result'), formatter: toolTipFormatter },
        ],
        noVirtualTable: true,
        columnExtensions: [
            { columnName: 'Status', width: '10%' },
            { columnName: 'Number', width: '10%' },
            { columnName: 'RoomNumber', width: '10%' },
        ],
        paging: true
    };

    return (
        <Modal closeIcon size="large" open={open} style={{ zIndex: 1000000 }} onClose={close} >
            <Modal.Header>{text("ReservationsStatusChange")}</Modal.Header>
            <Modal.Content style={{ height: 600, display: 'flex' }}>
                <GridPanel options={gridOptions} data={data} />
            </Modal.Content>
        </Modal>
    )
}

ReservationsUpdateStatusModal.propTypes = {
    data: PropTypes.array,
    onClose: PropTypes.func,
    startOpen: PropTypes.bool,
}

export default ReservationsUpdateStatusModal 